import { useEffect } from 'react';
import { injectAppleScript } from '../externalOauthLibs';

/**
 *
 * @param {String} state https://developer.apple.com/documentation/sign_in_with_apple/clientconfigi/3230956-state
 */
const useApple = (state) => {
  useEffect(() => {
    injectAppleScript();
  }, []);

  const signin = () => {
    if (!window.AppleID.stravaInit) {
      window.AppleID.auth.init({
        clientId: 'com.strava.app.sign.in',
        scope: 'name email',
        redirectURI: 'https://www.strava.com/o_auth/apple',
        state
      });
      window.AppleID.stravaInit = true;
    }
    window.AppleID.auth.signIn();
  };

  return { signin };
};

export default useApple;
